import React, { PureComponent } from 'react';

import axios from 'axios';
import Cookies from 'universal-cookie';
import Button from '@material-ui/core/Button/Button';
import Snackbar from '@material-ui/core/Snackbar';

import Header from '../../components/header/Header';
import WorldDetail from '../../components/world-detail/WorldDetail';
import WorldCreation from '../../components/world-creation/WorldCreation';

import './Instructor.scss';
import { CAMS_URL, FETCH_URL } from '../../constants/ServerLinks';
import { withRouter } from 'react-router-dom';

class Instructor extends PureComponent {
  constructor() {
    super();

    this.fetchURL = FETCH_URL;
    this.camsURL = CAMS_URL;

    this.cookies = new Cookies();
    this.token = this.cookies.get('token');
    this.origin = this.cookies.get('origin');

    this.state = {
      worldList: [],
      snackMsg: 'Welcome!',
      snackOpen: false,
      snackType: 'snack',
      snackAutoHideDuration: null,
      showCompleted: true,
      navLinks: [
        {
          name: 'Instructor',
          href: '',
          icon: '--',
          target: '_',
        },
        {
          name: 'Logout',
          href: '/logout',
          icon: 'iconLogout',
          target: '',
        },
        {
          name: 'Documentation',
          href: '/info',
          icon: 'iconInfo',
          target: '_self',
        },
        // {
        //     name: 'Frank Batten School',
        //     href: 'https://batten.virginia.edu',
        //     icon: 'iconBatten',
        //     target: '_blank',
        // },
        // {
        //     name: 'CLSG',
        //     href: 'https://www.clsgbatten.org',
        //     icon: 'iconClsg',
        //     target: '_blank',
        // },
      ],
    };
  }

  fetchWorldList = () => {
    axios
      .get(this.fetchURL + '/api/v1/world_list/', {
        headers: { Authorization: `Token ${this.token}` },
      })
      .then((response) => {
        // console.group("Instructor:fetchWorldList");
        // console.log(response.data);
        // console.groupEnd();
        if (response.data.success) {
          let worldList = response.data.data;
          this.setState({ worldList: worldList });
        }
      })
      .catch((error) => {
        console.log(error.response);
      });
  };

  fetchUserNameAndPhoto = () => {
    axios
      .all([
        axios.get(this.camsURL + '/api/auth/user', {
          headers: { Authorization: `Token ${this.token}` },
        }),
        // axios.get(this.camsURL + "/api/v1/users/photo/", {
        //   headers: { Authorization: `Token ${this.token}` },
        // }),
      ])
      .then(
        axios.spread((detailsResponse, photoResponse) => {
          if (detailsResponse.status === 200) {
            let rolesInfo = detailsResponse.data;
            // let photoInfo = photoResponse.data;
            this.setState(() => {
              return {
                navLinks: this.state.navLinks.map((item) => {
                  if (item.name === 'Instructor') {
                    item.name =
                      rolesInfo.first_name + ' ' + rolesInfo.last_name;
                    item.bg = '';
                    return item;
                  } else {
                    return item;
                  }
                }),
              };
            });
          }
        })
      )
      .catch((error) => {
        console.log(error);
      });
  };

  authUser = () => {
    axios
      .get(this.camsURL + '/api/auth/user', {
        headers: { Authorization: `token ${this.token}` },
      })
      .then((response) => {
        // console.group("Instructor:authUser");
        // console.log(response);
        if (response.data) {
          this.fetchWorldList();
          this.fetchUserNameAndPhoto();
        } else {
          window.location.replace('/');
        }
        // console.groupEnd();
      })
      .catch((error) => {
        console.log(error.response);
        window.location.replace('/');
      });
  };

  componentDidMount = () => {
    this.authUser();
  };

  createWorld = (data) => {
    return axios
      .post(
        this.fetchURL + '/api/v1/worlds/',
        {
          world_name: data.worldName,
          purpose: data.purpose,
          site_name: data.siteName,
        },
        {
          headers: { Authorization: `Token ${this.token}` },
        }
      )
      .then((response) => {
        if (response.data.success) {
          // console.group("Instrucor:createWorld");
          // console.log('World Added!');
          // console.log(response.data);
          // console.groupEnd();

          this.setState((prevState) => ({
            worldList: prevState.worldList.concat(response.data.data),
          }));

          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: 'snack-success',
            snackAutoHideDuration: 5000,
          });

          return true;
        } else {
          // console.log(response.data.message);
          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: 'snack-error',
            snackAutoHideDuration: 5000,
          });

          return false;
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({
          snackOpen: true,
          snackMsg: 'Something went wrong. Please try again later.',
          snackType: 'snack-error',
          snackAutoHideDuration: 5000,
        });

        return false;
      });
  };

  onNavLinkClick = (e, nav) => {
    e.preventDefault();

    if (nav.target === '_') {
      //   Nothing
    } else if (nav.target === '_blank') {
      window.open(nav.href, '_blank');
    } else if (nav.target === '_self') {
      this.props.history.push('/info');
    } else {
      this.setState({
        snackType: 'snack',
        snackOpen: true,
        snackMsg: 'Are you sure you want to logout?',
      });
    }
  };

  handleClose = () => {
    this.setState({ snackOpen: false });
  };

  logoutYes = () => {
    console.log('inside log out in instructor, token: ', this.token);
    this.setState({ requestSent: true });

    axios
      .post(
        this.camsURL + '/api/auth/logout',
        {},
        { headers: { Authorization: `Token ${this.token}` } }
      )
      .then((response) => {
        this.setState({ requestSent: false });

        if (response.status === 204 || response.status === 200) {
          this.setState({
            snackOpen: true,
            snackMsg: `Logout successful!`,
            snackType: 'snack-success',
            snackAutoHideDuration: 5000,
          });
          this.cookies.remove('token');
          this.cookies.remove('uid');
          this.cookies.remove('origin');
          window.location.replace('/');
        } else {
          this.setState({
            snackOpen: true,
            snackMsg: response.statusText,
            snackType: 'snack-error',
            snackAutoHideDuration: 5000,
          });
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({ requestSent: false });
      });
  };

  updateStatus = (e, worldId) => {
    e.preventDefault();
    const worldInfo = this.state.worldList.find(
      (world) => world.world_id === worldId
    );

    worldInfo &&
      axios
        .put(
          this.fetchURL + '/api/v1/worlds/',
          {
            world_id: worldInfo.world_id,
            is_active: !worldInfo.world_is_active,
          },
          { headers: { Authorization: `Token ${this.token}` } }
        )
        .then((response) => {
          if (response.data.success) {
            // console.group("Instructor:updateStatus");
            // console.log('Game status Updated!');
            // console.groupEnd();
            this.setState((prevState) => ({
              worldList: prevState.worldList.map((world) => {
                if (world.world_id === worldInfo.world_id) {
                  return Object.assign({}, world, {
                    world_is_active: !world.world_is_active,
                  });
                } else {
                  return world;
                }
              }),
              snackOpen: true,
              snackMsg: response.data.message,
              snackType: 'snack-success',
              snackAutoHideDuration: 5000,
            }));
          } else {
            // console.log(response.data.message);
            this.setState({
              snackOpen: true,
              snackMsg: response.data.message,
              snackType: 'snack-error',
              snackAutoHideDuration: 5000,
            });
          }
        })
        .catch((error) => {
          console.log(error.response);
          this.setState({
            snackOpen: true,
            snackMsg: 'Something went wrong. Please try again later.',
            snackType: 'snack-error',
            snackAutoHideDuration: 5000,
          });
        });
  };

  render() {
    return (
      <div>
        <Header />

        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={this.state.snackOpen}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          className={this.state.snackType}
          autoHideDuration={this.state.snackAutoHideDuration}
          onClose={this.handleClose}
          message={<span id="message-id">{this.state.snackMsg}</span>}
          action={
            this.state.snackType === 'snack'
              ? [
                  <Button key="yes" color="secondary" onClick={this.logoutYes}>
                    Yes
                  </Button>,
                  <Button key="no" color="inherit" onClick={this.handleClose}>
                    No
                  </Button>,
                ]
              : []
          }
        />

        <div className="nav__wrap">
          <ul className="nav__list">
            {this.state.navLinks.map((nav, index) => (
              <li key={index}>
                <button onClick={(e) => this.onNavLinkClick(e, nav)}>
                  <span
                    className={`nav__icon ${nav.icon}`}
                    style={
                      nav.icon === '--'
                        ? {
                            backgroundImage: `url(${nav.bg})`,
                            backgroundSize: 'cover',
                            borderRadius: '50%',
                            cursor: 'default',
                          }
                        : {}
                    }
                  />
                  <span
                    className="nav__link"
                    style={nav.icon === '--' ? { cursor: 'default' } : {}}
                  >
                    {nav.name}
                  </span>
                  <span className="nav__border" />
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="header__padding" />
        <div className="instructorDash__wrap">
          <div className="dash__outer">
            <WorldCreation createWorld={this.createWorld} />

            <div className="flex flex-items-center flex-justify-center gap__container">
              <div className="metrics__container">
                <div className={`shadow metrics__wrapper`}>
                  <div className="flex flex-auto unlist flex-justify-between">
                    <div className="container">
                      <h3>Your Worlds</h3>
                    </div>
                    <div className="container">
                      {this.state.worldList.length > 0 && (
                        <button
                          className="button"
                          onClick={() =>
                            this.setState((prevState) => {
                              return {
                                showCompleted: !prevState.showCompleted,
                              };
                            })
                          }
                        >
                          {this.state.showCompleted
                            ? 'Hide Completed'
                            : 'Show Completed'}
                        </button>
                      )}
                    </div>
                  </div>
                  <hr />

                  {this.state.worldList.map((item) => {
                    return (
                      <WorldDetail
                        key={item.world_id}
                        display={this.state.showCompleted}
                        updateStatus={this.updateStatus}
                        id={item.world_id}
                        name={item.world_name}
                        code={item.game_code}
                        skey={item.world_skey}
                        purpose={item.purpose}
                        is_active={item.world_is_active}
                        is_complete={item.world_is_complete}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Instructor);
